import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import EarnHistoryGraph from "@/components/app/EarnHistoryGraph.vue";
import BalanceOverview from "@/components/app/BalanceOverview.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticView',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EarnHistoryGraph),
    _createVNode(BalanceOverview)
  ], 64))
}
}

})